var _defs, _polygon, _polygon2, _line, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew307({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "12.66 5.23 7.97 2.52 7.97 7.94 12.66 5.23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.19 5.23 2.5 2.52 2.5 7.94 7.19 5.23"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.5,
    y1: 1.76,
    x2: 13.5,
    y2: 8.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.57,12.93V9.87h.86a1.5,1.5,0,0,1,.49.06.84.84,0,0,1,.38.27,1.33,1.33,0,0,1,.25.49,2.38,2.38,0,0,1,.09.7,2.31,2.31,0,0,1-.15.88,1.05,1.05,0,0,1-.39.51,1.18,1.18,0,0,1-.63.15Zm.33-.36h.53a.92.92,0,0,0,.49-.1.71.71,0,0,0,.26-.34,2.11,2.11,0,0,0,.12-.75,1.65,1.65,0,0,0-.13-.73.68.68,0,0,0-.32-.36,1.12,1.12,0,0,0-.43-.06H4.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.88,11.86l.34.1a1.47,1.47,0,0,1-.39.77,1,1,0,0,1-.67.25,1,1,0,0,1-.6-.17,1.16,1.16,0,0,1-.4-.54A2.21,2.21,0,0,1,7,11.38a2,2,0,0,1,.16-.85A1.13,1.13,0,0,1,7.58,10a1.07,1.07,0,0,1,.61-.18.91.91,0,0,1,.62.22,1.32,1.32,0,0,1,.37.67l-.33.09c-.11-.42-.34-.63-.67-.63a.81.81,0,0,0-.44.12.89.89,0,0,0-.29.4,2,2,0,0,0-.11.69,1.69,1.69,0,0,0,.22.94.7.7,0,0,0,.59.32.68.68,0,0,0,.47-.19A1,1,0,0,0,8.88,11.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.35,12.93l-1-3.06h.36l.65,2.23c0,.17.1.34.13.5,0-.17.09-.34.14-.5l.67-2.23h.34l-1,3.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew307);
export default __webpack_public_path__ + "static/media/Symbolpack_New_307.913b2c8a1dcea8694c87a1a205ec6334.svg";
export { ForwardRef as ReactComponent };